import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  modalWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xl,

    padding: SPACES.xxl,

    minHeight: 340,
    minWidth: 320,
    maxHeight: 'calc(100vh - 80px)',
    maxWidth: 'calc(100vw - 40px)',
  },
  title: {
    '&&': {
      textAlign: 'center',
      fontSize: FONTS.SIZES.xl,
      fontWeight: FONTS.WEIGHTS.bold,
      color: theme.palette.custom.darkBlue2,
    },
  },
  label: {
    '&&': {
      marginBottom: SPACES.xxs,

      fontSize: FONTS.SIZES.xl,
      fontWeight: FONTS.WEIGHTS.bold,
      color: theme.palette.custom.darkBlue2,
    },
  },
  tableHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  value: {
    '&&': {
      fontSize: FONTS.SIZES.default,
      color: theme.palette.custom.darkBlue2,
    },
  },
  parsedWrapper: {
    '&&': {
      '& > p': {
        margin: `${SPACES.xxxs} 0px`,
      },
      '& > *': {
        margin: 0,
      },
      border: `1px solid ${theme.palette.custom.darkBlue2}`,

      padding: SPACES.s,

      // wordBreak: 'break-all',
    },
  },
}))
